import { DefaultValue, selector } from 'recoil';
import { VoucherTypeEnum } from '@zurich/api/party';
import { localPartyRelationAtom } from '../atoms';
export const localPartyRelationTypeSelector = selector({
    key: 'local/partyRelation/relationType',
    get: ({ get }) => {
        const relation = get(localPartyRelationAtom);
        return relation?.partyRelationType;
    },
    set: ({ get, set }, value) => {
        const relation = get(localPartyRelationAtom);
        set(localPartyRelationAtom, {
            ...relation,
            partyRelationType: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyRelationSharesSelector = selector({
    key: 'local/partyRelation/shares',
    get: ({ get }) => {
        const relation = get(localPartyRelationAtom);
        return relation?.shares ?? null;
    },
    set: ({ get, set }, value) => {
        const relation = get(localPartyRelationAtom);
        set(localPartyRelationAtom, {
            ...relation,
            shares: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyRelationPartyASelector = selector({
    key: 'local/partyRelation/partyA',
    get: ({ get }) => {
        const relation = get(localPartyRelationAtom);
        return relation?.partyA;
    },
    set: ({ get, set }, value) => {
        const relation = get(localPartyRelationAtom);
        set(localPartyRelationAtom, {
            ...relation,
            partyA: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyRelationPartyBSelector = selector({
    key: 'local/partyRelation/partyB',
    get: ({ get }) => {
        const relation = get(localPartyRelationAtom);
        return relation?.partyB;
    },
    set: ({ get, set }, value) => {
        const relation = get(localPartyRelationAtom);
        set(localPartyRelationAtom, {
            ...relation,
            partyB: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyRelationVoucherSelector = selector({
    key: 'local/partyRelation/voucher',
    get: ({ get }) => {
        const relation = get(localPartyRelationAtom);
        return relation?.voucherType || null;
    },
    set: ({ get, set }, value) => {
        const relation = get(localPartyRelationAtom);
        set(localPartyRelationAtom, {
            ...relation,
            voucherType: value instanceof DefaultValue ? VoucherTypeEnum.AMZ : value,
        });
    },
});
